import { commonTypes } from '../common';
import { getCommitmentOptions } from '../normalizers/uiNeeds';

export const types = {
  SET_CA_NEEDS: 'UINEEDS/SET_CA_NEEDS',
};

export const initialState = {
  addToCartNeeds: {
    commitmentOptions: null,
  },
};

const UINeedsCommitment = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_ADD_TO_CART_NEEDS: {
      const { response } = action.payload;
      const { components } = response;
      const { deviceInfo } = state;
      const { swap } = { ...deviceInfo };
      const { taxName, options } = getCommitmentOptions(components, swap);

      if (options.length > 1) {
        const newState = { ...state };
        newState.addToCartNeeds = {
          commitmentOptions: options,
          taxName,
        };
        return {
          state: newState,
          stepsMustBeEvaluated: true,
        };
      }
      return null;
    }
    default:
      return null;
  }
};

export const actions = {};

export default UINeedsCommitment;
